import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from "@angular/common/http";
// import { Observable } from "rxjs/internal/Observable";
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

import { OAuthService } from 'angular-oauth2-oidc';

//@Injectable()
@Injectable({
    providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {

    constructor(
        private _router: Router,
        private _oauthService: OAuthService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let token = window.localStorage.getItem('token');
        //console.log("token: " + token);

        if (token) {
            request = request.clone({
                setHeaders: {
                    token: token
                    // token: 'Ncnr ' + token
                }
            });
        }
        // else {
        //     this.router.navigateByUrl('/login');
        // }

        return next.handle(request).pipe(
            catchError((err: HttpErrorResponse) => {

                console.log(err);

                if (err.status === 401) {
                    window.localStorage.removeItem("data");
                    window.localStorage.removeItem("token");
                    // window.localStorage.clear();
                    this._oauthService.logOut();
                    this._router.navigate(['login']);
                    // this.router.navigateByUrl('/login');
                }

                // if (err.status === 502 || err.status === 0 && !err.ok) {
                //     window.localStorage.clear();
                //     this._oauthService.logOut();
                //     this._router.navigate(['mantenimiento']);
                // }

                return throwError(err);
            })
        );
    }
}
